import { Injectable } from '@angular/core';
import { ApiService, RepositoryImpl } from '@homeleite/arch';
import { Breeder, BreederSummary } from './breeder';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class BreedersApiRepository extends RepositoryImpl<BreederSummary, Breeder> {
    constructor(api: ApiService) {
        super(api.root.path('/breeders'), BreederSummary, Breeder);
    }

    public syncBreeders(since: string) {
        const params: HttpParams = new HttpParams().set('since', since);
        return this.api.path('fetch').postJson({}, { params });
    }
}
